import api from './api';

export const fetchMessageLogs = (params) =>
  api.get('/message-logs', { params }).then((r) => r.data);

export const fetchMessageLogById = (id) =>
  api.get(`/message-logs/${id}`).then((r) => r.data);
